import { Palette } from '@mui/material';
import { TypographyOptions } from '@mui/material/styles/createTypography';
import theme from './theme';

type MUITypography = (palette: Palette) => TypographyOptions;

export const typography: MUITypography = () => ({
  fontFamily: 'Usual, arial, sans-serif',
  htmlFontSize: 16,
  fontWeightLight: 200,
  fontWeightRegular: 'normal',
  fontWeightMedium: 500,
  fontWeightBold: 'bold',
  allVariants: {
    fontSize: 16,
    lineHeight: 1.25,
    fontWeight: 'normal',
  },
  h1: {
    fontSize: 24,
    fontWeight: '400',
    lineHeight: '40px',
    color: '#00223A',
  },
  h2: {
    fontSize: 20,
    fontWeight: '400',
    color: '#00223A',
  },
  h3: {
    fontSize: 18,
    fontWeight: '400',
    color: '#00223A',
  },
  h4: {
    fontSize: 16,
    fontWeight: '400',
    color: '#00223A',
  },
  // h5: {},
  h6: {
    fontSize: 15,
    fontWeight: '500',
    color: '#00223A',
  },
  body1: {
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
  },
  // caption: {},
  subtitle1: {
    fontSize: 20,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: 18,
  },
  overline: {
    fontSize: 13,
    lineHeight: '13px',
    verticalAlign: 'baseline',
  },
  caption: {
    fontSize: '12px',
    color: '#636D73',
  },
  // button: {},
});
